<app-page-header></app-page-header>
<div class="body">
  <div class="bckgd-img"></div>
  <div class="container">
    <!-- Seção: Meu perfil -->
    <section
      class="account-section card shadow-sm"
      [ngClass]="{ editing: isEditing }"
    >
      <header class="section-header">
        <span class="section-icon"><i class="pi pi-user"></i></span>
        <div>
          <h2 class="section-title">{{ "user-profile-edit.profile-title" | translate }}</h2>
          <p class="section-subtitle">{{ "user-profile-edit.profile-subtitle" | translate }}</p>
        </div>
      </header>

      <form class="profile-grid" [formGroup]="userForm">
        <div class="profile-field">
          <label for="inputNome" class="form-label">{{ "user-profile-edit.form-name" | translate }}</label>
          <input type="text" class="form-control" id="inputNome" formControlName="firstName" readonly />
        </div>
        <div class="profile-field">
          <label for="inputEmail" class="form-label">{{ "user-profile-edit.form-email" | translate }}</label>
          <input type="text" class="form-control" id="inputEmail" formControlName="email" readonly />
        </div>
        <div class="profile-field">
          <label for="inputUsuario" class="form-label">{{ "user-profile-edit.form-user" | translate }}</label>
          <input type="text" class="form-control" id="inputUsuario" formControlName="user" readonly />
        </div>
        <div class="profile-actions">
          <p-button
            severity="success"
            [outlined]="true"
            icon="pi pi-pencil"
            [label]="'user-profile-edit.button-edit-profile' | translate"
            [disabled]="isEditing"
            (onClick)="enterEditMode()"
          />
        </div>
      </form>
    </section>

    @if (isEditing) {
      <app-useredit [user]="user" (newUserData)="getNewUserData($event)"></app-useredit>
    }

    <!-- Seção: Segurança da conta -->
    <app-mfa-settings></app-mfa-settings>
  </div>
</div>
